import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import Button from 'components/shared/Button'
import Price from 'components/shared/Price'
import { useResolutions } from 'store/resolutions'
import { FormattedMessage, useIntl } from 'react-intl'
import { UpsellType } from 'store/upsell-slice'
import { CabanaType } from 'store/cabana-slice'
import { TransportType } from 'store/transport-slice'
import { Wrapper } from './styles'
import Loader from 'components/shared/Loader'
import { useApp } from 'store/steps'
//import { SELFCARE_STEPS } from 'routes/steps'
import { useNavigate } from 'react-router-dom'
import { formatPrice } from 'helpers/helpers'

export interface AttractionReservationProps {
    title: string
    price: number
    otherPrice?: number
    lowestPrice?: number
    isPriceFrom: boolean
    pricePer?: 'person' | 'couple'
    images: string
    creator?: JSX.Element
    upsellType?: UpsellType | CabanaType | TransportType
    isPriceLoading?: boolean
    stepToEditId: string
    isActive?: boolean
    handleModalOpening?: (
        upsellType: UpsellType | CabanaType | TransportType
    ) => void
}

const AttractionReservation = ({
    title,
    price,
    otherPrice,
    lowestPrice,
    isPriceFrom,
    pricePer,
    images,
    isPriceLoading,
    stepToEditId,
    upsellType,
    handleModalOpening,
}: AttractionReservationProps) => {
    const { isTablet } = useResolutions()
    const { formatMessage } = useIntl()
    const navigate = useNavigate()
    const { getPath } = useApp()
    const handleButtonClick = () => {
        navigate(`${getPath('edit_order')}#${stepToEditId}`)
    }

    return (
        <Wrapper
            direction={['column', 'row']}
            align={['center', 'flex-start']}
            justify={['flex-start', 'space-between']}
            gap={[16, 0]}
            wrap="wrap"
            isFullWidth
        >
            <Box
                direction={['column', 'row']}
                isFullWidth
                align="center"
                gap={[0, 40]}
                pr={[16, 0]}
                pl={[16, 0]}
                pt={[16, 0]}
                pb={16}
            >
                <Box
                    direction={['row', 'row-reverse']}
                    align="center"
                    justify={['space-between', 'flex-end']}
                    pb={[12, 0]}
                    gap={16}
                    isFullWidth={isTablet}
                    hasNoShrink
                >
                    <Box>
                        <Text variant="heading4" mb={[4, 8]}>
                            {title}
                        </Text>
                        <Text
                            as="button"
                            variant="bodyStrong"
                            color="secondary_500"
                            onClick={() =>
                                upsellType &&
                                handleModalOpening &&
                                handleModalOpening(upsellType)
                            }
                            data-testid={`selfcare-improve-${upsellType}-button-about`}
                        >
                            <FormattedMessage
                                id="global.btn.learn_more"
                                defaultMessage="Dowiedz się więcej"
                            />
                        </Text>
                    </Box>

                    <img src={images} alt="attraction" />
                </Box>
                <Box
                    direction={['row', 'row-reverse']}
                    align={[lowestPrice ? 'flex-start' : 'center', 'center']}
                    justify={['space-between', 'flex-start']}
                    isFullWidth
                    gap={24}
                    pt={[16, 0]}
                    data-testid={`selfcare-improve-${upsellType}-button-add`}
                >
                    <Button
                        variant="secondary"
                        hasArrow={false}
                        width="initial"
                        onClick={handleButtonClick}
                    >
                        <FormattedMessage
                            id="global.btn.add"
                            defaultMessage="Dodaj"
                        />
                    </Button>

                    {isPriceLoading ? (
                        <Loader hasNoShrink />
                    ) : (
                        <Box
                            direction="column"
                            align="flex-end"
                            isFullWidth
                            gap={4}
                        >
                            <Box
                                direction="row"
                                justify="space-between"
                                gap={4}
                                align="center"
                            >
                                {!!otherPrice && (
                                    <Text
                                        variant="body"
                                        color={
                                            isTablet
                                                ? 'grayscale_900'
                                                : 'grayscale_800'
                                        }
                                        isStrikeThrough
                                    >
                                        {formatPrice(otherPrice, true)}
                                    </Text>
                                )}
                                <Price
                                    value={price}
                                    description={
                                        isPriceFrom
                                            ? formatMessage({
                                                  id: 'global.price.label_from',
                                                  defaultMessage: 'od',
                                              })
                                            : undefined
                                    }
                                    per={pricePer}
                                    isCapitalized
                                    size="bodyStrong"
                                    currencySize={
                                        otherPrice
                                            ? 'bodySmallStrong'
                                            : 'bodyStrong'
                                    }
                                    descriptionSize={
                                        isTablet
                                            ? 'bodyExtraSmall'
                                            : 'bodyStrong'
                                    }
                                />
                            </Box>
                            {!!lowestPrice && (
                                <Text
                                    variant="bodyExtraSmall"
                                    color="grayscale_800"
                                    align="right"
                                >
                                    <FormattedMessage
                                        id="order.discount.lowest_price_30_days_info"
                                        defaultMessage="Najniższa cena z 30 dni przed wprowadzeniem obniżki:"
                                    />{' '}
                                    {formatPrice(lowestPrice, true)}
                                </Text>
                            )}
                        </Box>
                    )}
                </Box>
            </Box>
        </Wrapper>
    )
}

export default AttractionReservation
